<ul class="ppt-container">
  <h3 class="ppt-title">Proprietários</h3>
  <li class="ppt-items" [class.ppt-items__border]="last" *ngFor="let item of items; let i = index; let last = last">
    <div class="ppt-item-container">
      <p *ngIf="item.name"><span>Nome: </span>{{ item.name }}</p>
      <p *ngIf="item.rg || item.cpf"><span *ngIf="item.rg">RG: </span>{{ item.rg }}<span *ngIf="item.cpf"> / CPF: </span>{{ item.cpf }}</p>
      <p *ngIf="item.email"><span>Email: </span>{{ item.email }}</p>
      <p *ngIf="item.phone_main"><span>Telefone: </span>{{ item.phone_main.ddi +' '+item.phone_main.phone }}</p>
      <div *ngFor="let phone of item.phone_alternative">
        <p *ngIf="item.phone_alternative.length"><span>Telefone Alternativo: </span>{{ phone.ddi +' '+ phone.phone }}</p>
      </div>
    </div>
    <button class="remove-item" id="btn-remove-proprietario" (click)="removeItem(i)">
      <img src="../../../../assets/svgs/i_dot_options.svg" alt="Opções">
    </button>
  </li>
  <button id="btn-add-proprietario" class="btn-add" (click)="openModal()">
    <span>Adicionar proprietário</span>
  </button>
</ul>
<app-proprietary-modal *ngIf="showModal" titleModal="Adicionar proprietário" (closeModal)="showModal = $event" (sendItems)="sendItems($event)"></app-proprietary-modal>